import React, {Component} from 'react';
import {Collapse, Nav, Navbar, NavItem} from 'reactstrap';
import {BASE_PATH, LOGO_PATH, MD_BREAKPOINT} from "../Constants/Constants";
import {NavLink} from 'react-router-dom';
import Media from "react-media";
import {PURPLE_GRADIENT_TO_RIGHT} from "../Constants/Colors";

class NavLinkItem extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			hover: false,
			reference: props.reference
		};
		this.hoverOn = this.hoverOn.bind(this);
		this.hoverOff = this.hoverOff.bind(this);
		this.getColor = this.getColor.bind(this);
		this.isInViewport = this.isInViewport.bind(this);
	}

	hoverOn() {
		this.setState({hover: true});
	}

	hoverOff() {
		this.setState({hover: false});
	}

	isInViewport(reference, offset = 0) {
		if (!reference || !reference.current) return false;
		const top = reference.current.getBoundingClientRect().top;
		return (top + offset) >= (-3*window.innerHeight)/4 && (top - offset) <= (window.innerHeight)/4;
	}

	getColor(reference) {
		// //console.log(this.props.active, this.props.title);
		if(this.isInViewport(reference)) {
			//console.log(this.props.title, "On Screen");
		// }
		// if (this.props.active === this.props.title) {
			return "#ffc107";
		} else if (this.state.hover) {
			return "#ffca28";
		} else {
			return "#fff";
		}
	}

	render() {
		let {title, link, onClick, styles, reference} = this.props;
		return (
			<NavItem className="nav-link" onMouseEnter={this.hoverOn} onMouseLeave={this.hoverOff}>
				<NavLink onClick={(e) => {
					onClick(title, reference);
				}}
								 to={link} className="text-decoration-none" style={{...styles, color: this.getColor(reference)}}>
					{/*<Link to="/">*/}
					{title}
					{/*</Link>*/}
				</NavLink>
			</NavItem>
		)
	}
}

const NavbarBrandLink = (props) => (
	<div className="nav navbar navbar-brand text-light text-uppercase">
		<NavLink className="text-light" style={{textDecoration: "none"}} to={props.to}>
			<img alt="LALIT JAIN" src={props.imagePath} style={props.styles ? props.styles : {height: "50px"}}/>
		</NavLink>
	</div>
);

export default class Header extends Component {

	constructor(props) {
		super(props);
		let styles = props.window_width >= MD_BREAKPOINT ? props.styles : props.styles.small;
		this.state = {
			isOpen: false,
			navbarId: this.props.parentName + "Navbar",
			togglerId: this.props.parentName + "Toggler",
			navbarBackground: null,
			styles: styles,
			active: null
		};
		this.toggle = this.toggle.bind(this);
		this.setActive = this.setActive.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
	}

	handleScroll() {
		this.setState((state) => {
			let styles = state.styles;
			let headerBackground = null;
			if (this.props.references && this.props.references.main && this.props.window_width < MD_BREAKPOINT && this.props.changeNavbarColorOnScroll) {
				let node = document.getElementById("main");
				//this.props.references.main.current.getElementById("#main");
				let top = node.getBoundingClientRect().top;
				headerBackground = top < -10 ? PURPLE_GRADIENT_TO_RIGHT : null;
				styles = {...styles, backgroundImage: headerBackground};
				styles.navItemsContainer.backgroundImage = top >= -10 ? PURPLE_GRADIENT_TO_RIGHT : null;
			}
			return {...state, styles: styles};
		});
	}

	componentDidMount() {
		if (this.props.hasOwnProperty("updateNavbarHeight")) {
			this.props.updateNavbarHeight(document.getElementById(this.state.navbarId).clientHeight)
		}
		if (this.props.hasOwnProperty("updateNavbarWidth")) {
			this.props.updateNavbarWidth(document.getElementById(this.state.navbarId).clientWidth)
		}
		window.addEventListener('scroll', this.handleScroll);
		this.handleScroll();
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	toggle() {
		//console.log("Toggler Clicked.");
		this.setState({
			isOpen: !this.state.isOpen,
		});
	}

	setActive(title) {
		////console.log("setActive Called on", title);
		this.setState(state=>({active: title}));
		////console.log(this.state.active)
	}

	styles = {...this.props.styles};

	onNavItemClick(title, reference) {
		//console.log("click", title, reference);
		this.toggle();
		if (reference && reference.current && this.state.active !== title) {
			this.setActive(title);
			//console.log("Scroll to", reference.current.offsetTop);
			window.scrollTo(0, reference.current.offsetTop);
		}
	};

	render() {
		// let breakpoint = 786;
		//console.log(this.state);
		let styles = this.state.styles; //this.props.window_width >= MD_BREAKPOINT ? this.styles : this.styles.small;
		//console.log("Header State Styles", styles);

		return (
			//backgroundImage: this.styles.backgroundImage
			<Navbar id={this.state.navbarId}
							style={{...styles, zIndex: 10000}}
							className="text-light"
							expand="md">
				<NavbarBrandLink
					to={BASE_PATH}
					imagePath={LOGO_PATH}
					styles={styles.image}
				/>

				<Media query={"(min-width: " + MD_BREAKPOINT + "px)"}>
					{
						matches => matches ?
							null
							:
							<a id={this.state.togglerId} onClick={this.toggle} className="text-light"
								 style={{position: "fixed", top: "10px", right: "10px"}}>
								<span className="fa fa-2x fa-navicon"></span>
							</a>
					}
				</Media>

				<Collapse isOpen={this.state.isOpen} navbar>
					<Nav navbar style={{...styles.navItemsContainer, visible: this.state.isOpen}}>
						{
							this.props.navItems.map((item, index) => (
								<NavLinkItem onClick={(title, reference) => this.onNavItemClick(title, reference)}
														 title={item.title}
														 link={item.path}
														 key={index}
														 active={this.state.active}
									// setActive={(title)=>this.setActive(title)}
														 reference={this.props.references ? this.props.references[item.title] : {[item.title]: null}}
														 styles={styles.navItemsContainer.navbarItem}
								/>
							))
						}
					</Nav>
				</Collapse>
			</Navbar>

			// <Jumbotron className="no-print" style={{borderRadius: "0px", padding: "0.25rem", color: "#E8F5E9", backgroundColor: "#311B92"}}>
			// 	<h2 style={{textAlign: "center"}}>My Resume</h2>
			// </Jumbotron>
		);
	}
}